import { useTranslation } from "react-i18next";
import type { CalendarEvent } from "./schedule-events";
import { platformTones } from "./platform-tone";

// Times are minutes within the displayed day; split noon-crossing streams across rings.
type ClockEvent = Pick<CalendarEvent, "id" | "start" | "end" | "platform" | "lane" | "lanes">;

export function StreamClock({ events }: { events: ClockEvent[] }) {
  const { t } = useTranslation();
  const hasMorning = events.some(event => event.start < 720 && event.end > 0);
  return (
    <svg viewBox="0 0 100 100" role="img" aria-label={t("visualizer.clockDescription")} className="mx-auto w-full max-w-28">
      <circle cx="50" cy="50" r="35" fill="none" stroke="#e5e5e5" strokeWidth="4" />
      {hasMorning && <circle cx="50" cy="50" r="22" fill="none" stroke="#e5e5e5" strokeWidth="4" />}
      {Array.from({ length: 12 }, (_, hour) => (
        <line key={hour} x1="50" y1="9" x2="50" y2={hour % 3 === 0 ? 14 : 11}
          stroke="#a3a3a3" strokeWidth="1" transform={`rotate(${hour * 30} 50 50)`} />
      ))}
      {[0, 720].map(periodStart => events.map(event => {
        const start = Math.max(periodStart, event.start);
        const end = Math.min(periodStart + 720, event.end);
        if (end <= start) return null;
        return <circle key={`${periodStart}-${event.id}`} cx="50" cy="50"
          r={(periodStart === 0 ? 22 : 35) - event.lane * 3} fill="none"
          stroke={platformTones[event.platform].stroke}
          strokeWidth={event.lanes > 1 ? 2.5 : 4} strokeLinecap="round"
          pathLength="720" strokeDasharray={`${end - start} ${720 - (end - start)}`}
          strokeDashoffset={-(start - periodStart)} transform="rotate(-90 50 50)" />;
      }))}
      <g fill="#737373" fontSize="7" fontFamily="monospace" textAnchor="middle">
        <text x="50" y="7">12</text><text x="95" y="52">3</text>
        <text x="50" y="98">6</text><text x="5" y="52">9</text>
      </g>
    </svg>
  );
}
